function ConfirmEmailView(props) {
  return (
    <div>
      {props.subscriptionComplete &&
        <div className="alert alert-success" role="alert">
          Your subscription is active. Confirm your email to sign in.
        </div>}
      <p>You have signed up for Jashsoft. Please check your email to confirm your account.</p>
    </div>
  );
}

export default ConfirmEmailView;
